import { services } from '@/utils'

import render from './render'

export default {
  name: 'SimpleLayout',

  computed: {
    links() {
      const result = []
      switch (this.$route.name) {
        case services.login: {
          result.push(services.registration)
          break
        }

        default: {
          result.push(services.login)
          break
        }
      }
      result.push('documentation')

      return result
    }
  },

  render
}
